import type { NewsStory } from '../../ai/provider.js';

export function newsVideoPrompt(scope: 'us' | 'local', story: NewsStory): string {
  const base = [
    'A short looping news visual, photographic style, minimal motion.',
    `Scene relevant to: ${story.headline}.`,
    'Aspect 16:9.',
  ];
  if (scope === 'local' && story.team_or_landmark) {
    base.push(`Include the ${story.team_or_landmark} prominently if it fits naturally.`);
  }
  base.push('No text overlays inside the video.');
  return base.join(' ');
}
